import { terrainOf } from '../data/terrains.js';
/**
 * Grounds whose Wang corners win over the bank (TerrainField.vertexAt): a
 * walkable tile right north of one is drawn with its south half wet, which
 * is where a character's feet stand. Thicket is foliage, its edge reads as
 * leaves over the feet; a bridge is planks over its river.
 */
const WET = new Set(['w', 'm', 'i']);
/**
 * Whether a walkable tile is a north bank: water (or bog, or ice) right below
 * it. It is painted half wet, so walking it puts the feet in the water; the
 * zones block it instead (ADR 0081).
 */
export function isNorthBank(here, below) {
    return here !== 'b' && terrainOf(here).walkable && below !== undefined && WET.has(below);
}
/**
 * Collision rows from ground rows: `#` on blocking terrain and on north
 * banks, but for the banks `open` keeps (a way the generator cannot close).
 */
export function rowsOfGround(ground, open = () => false) {
    return ground.map((row, y) => row.replace(/./g, (c, x) => {
        if (!terrainOf(c).walkable)
            return '#';
        return isNorthBank(c, ground[y + 1]?.[x]) && !open(x, y) ? '#' : '.';
    }));
}
//# sourceMappingURL=banks.js.map